export default __webpack_public_path__ + "static/media/kiara.3c493b6c.jpeg";